import React, { useEffect, useState } from 'react'
import Header from '../components/Header'
import Footer from '../components/Footer'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { IoIosArrowForward, IoIosArrowBack } from 'react-icons/io'
import Carousel from 'react-multi-carousel'
import 'react-multi-carousel/lib/styles.css'
import Rating from '../components/Rating'
import { FaHeart } from 'react-icons/fa6'
import { FaFacebookF, FaRegHeart } from 'react-icons/fa'
import { FaInstagramSquare } from 'react-icons/fa'
import Reviews from '../components/Reviews'
import { Pagination, Autoplay } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/autoplay'
import { Swiper, SwiperSlide } from 'swiper/react'
import { useDispatch, useSelector } from 'react-redux'
import {
  product_details,
  get_categories,
  get_reviews,
} from '../store/reducers/homeReducer'
import { useTranslation } from 'react-i18next'
import toast from 'react-hot-toast'
import { backend_url_img } from '../api/server'
import { socket } from '../utils/utils'
import {
  add_to_card,
  get_card_products,
  messageClear,
  add_to_wishlist,
  get_wishlist,
} from '../store/reducers/cardReducer'
import { getCurrentTime } from '../utils/timeConvertor'
import ProductSpecifications from '../components/products/ProductSpecifications '

const Details = () => {
  const navigate = useNavigate()
  const { slug } = useParams()
  const dispatch = useDispatch()
  const { t, i18n } = useTranslation()
  const currentLanguage = i18n.language
  const isRTL = currentLanguage === 'ar' || currentLanguage === 'kr'

  const { product, relatedProducts, totalReview, categoriesView } = useSelector(
    (state) => state.home
  )

  const { userInfo } = useSelector((state) => state.auth)
  const { wishlist, errorMessage, successMessage } = useSelector(
    (state) => state.card
  )
  const [loading, setLoading] = useState(true)
  const [recentProducts, setRecentProducts] = useState([])
  const [image, setImage] = useState('')
  const [state, setState] = useState('description')
  const [categoryInfo, setCategoryInfo] = useState(null)

  const [quantity, setQuantity] = useState(1)


  

  useEffect(() => {
    // if (!socket) {
    //   console.error('Socket is not initialized')
    //   return
    // }
    socket.on('productUpdate', (data) => {
      dispatch(product_details(slug))
    })
    return () => {
      socket.off('productUpdate')
    }
  }, [slug])

  useEffect(() => {
    const fetchData = async () => {
      setImage('')
      setLoading(true)
      dispatch(get_categories())
      dispatch(product_details(slug))
      dispatch(get_wishlist(userInfo?.id))

      if (product && Object.keys(product).length > 0) {
        const recentProducts =
          JSON.parse(localStorage.getItem('recentProducts')) || []
        if (!recentProducts.some((item) => item._id === product._id)) {
          const currentTime = getCurrentTime()
          const productWithTimestamp = { ...product, timestamp: currentTime }
          recentProducts.push(productWithTimestamp)
          localStorage.setItem('recentProducts', JSON.stringify(recentProducts))
        }
      }

      setTimeout(() => {
        setLoading(false)
      }, 1000)
    }

    fetchData()
  }, [slug])

  const isFavorite = wishlist?.some(
    (item) => item.productId._id === product._id
  )

  useEffect(() => {
    const storedProducts =
      JSON.parse(localStorage.getItem('recentProducts')) || []
    setRecentProducts(storedProducts)
  }, [slug])

  const [selectedPacks, setSelectedPacks] = useState({})

  useEffect(() => {
    if (product && product.packs?.length > 0) {
      setSelectedPacks((prev) => {
        // prevent overwriting if already selected
        if (prev[product._id]) return prev
        return { ...prev, [product._id]: product.packs[0] }
      })
    }
    dispatch(get_reviews({ productId: product._id, pageNumber: 1 }))
  }, [product, setSelectedPacks, dispatch])

  useEffect(() => {
    if (!categoriesView || categoriesView.length === 0 || !product.categoryId)
      return

    const getCategoryInfo = (categoryId) => {
      const matchedCategory = categoriesView?.find((c) => c._id === categoryId)

      if (matchedCategory) {
        const nameInLanguage = (() => {
          switch (currentLanguage) {
            case 'ar':
              return matchedCategory.arName
            case 'kr':
              return matchedCategory.kuName
            default:
              return matchedCategory.enName
          }
        })()

        return { categoryId: matchedCategory._id, name: nameInLanguage }
      }

      return null
    }

    const info = getCategoryInfo(product.categoryId)
    setCategoryInfo(info)
  }, [categoriesView, product.categoryId, currentLanguage])

  const responsive = {
    superLarge: {
      breakpoint: { max: 4000, min: 1280 },
      items: 6,
    },
    large: {
      breakpoint: { max: 1280, min: 1024 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 1024, min: 768 },
      items: 5,
    },
    tablet: {
      breakpoint: { max: 768, min: 480 },
      items: 4,
    },
    mobile: {
      breakpoint: { max: 480, min: 0 },
      items: 3,
    },
  }

  // const [quantity, setQuantity] = useState(1)

  // const inc = () => {
  //   if (quantity >= product.stock) {
  //     toast.error('Out of Stock')
  //   } else {
  //     setQuantity(quantity + 1)
  //   }
  // }

  // const dec = () => {
  //   if (quantity > 1) {
  //     setQuantity(quantity - 1)
  //   }
  // }

  const getProductName = (product) => {
    switch (currentLanguage) {
      case 'ar':
        return product?.arName
      case 'kr':
        return product?.kuName
      default:
        return product?.enName
    }
  }

  const getProductDescription = (product) => {
    switch (currentLanguage) {
      case 'ar':
        return product?.arDescription
      case 'kr':
        return product?.kuDescription
      default:
        return product?.enDescription
    }
  }

  const handleAddToCart = () => {
    const createdAt = getCurrentTime()
    if (!userInfo) {
      navigate('/login')
      return
    }

    if (!selectedPacks[product._id]) return

    const selectedPack = selectedPacks[product._id]

    const info = {
      userId: userInfo.id,
      productId: product._id,
      quantity: quantity, // 👈 from state
      packs: [selectedPack],
      createdAt: createdAt,
    }

    dispatch(add_to_card(info))
  }

  const add_wishlist = () => {
    const createdAt = getCurrentTime()
    if (!userInfo) {
      navigate('/login')
      return
    }

    if (!selectedPacks[product._id]) return

    const selectedPack = selectedPacks[product._id]

    const info = {
      userId: userInfo.id,
      productId: product._id,
      quantity: quantity, // 👈 from state
      packs: [selectedPack],
      createdAt: createdAt,
    }
    dispatch(add_to_wishlist(info))
  }

  useEffect(() => {
    if (successMessage) {
      toast.success(successMessage)
      dispatch(messageClear())
      dispatch(get_card_products(userInfo?.id))
      dispatch(get_wishlist(userInfo?.id))
    }
    if (errorMessage) {
      toast.error(errorMessage)
      dispatch(messageClear())
    }
  }, [successMessage, errorMessage])

  return (
    <div>
      <Header />
      <section className=" mt-5 bg-cover bg-no-repeat relative bg-left">
        <div className="absolute left-0 top-0 w-full h-full bg-[#2422228a]">
          <div className="w-[65%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto">
            <div className="flex flex-col justify-center gap-1 items-center h-full w-full text-white"></div>
          </div>
        </div>
      </section>

      <section>
        <div className="bg-slate-100 py-5 mb-2">
          <div className="w-[68%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto">
            <div className="flex justify-start items-center text-md text-slate-600 w-full">
              <Link to="/">{t('home.home')}</Link>
              <span>{isRTL ? <IoIosArrowBack /> : <IoIosArrowForward />}</span>
              <Link
                to={`/products?category=${product.category}&categoryId=${product.categoryId}`}
              >
                {categoryInfo?.name}
              </Link>

              <span>{isRTL ? <IoIosArrowBack /> : <IoIosArrowForward />}</span>
              <span className="text-[#B65278]">{getProductName(product)} </span>
            </div>
          </div>
        </div>
      </section>

      <section className="py-8">
        <div className="w-[68%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto">
          <div className="grid grid-cols-2 md-lg:grid-cols-1 gap-8">
            <div>
              <div className="border rounded-md aspect-square">
                {loading ? (
                  <div className="flex justify-center items-center min-h-full">
                    <div className="w-12 h-12 border-4 border-primary border-t-transparent rounded-full animate-spin"></div>
                  </div>
                ) : (
                  <img
                    className="w-full h-full object-cover"
                    src={
                      image
                        ? `${backend_url_img}/${image}`
                        : `${backend_url_img}/${product?.images?.[0]}`
                    }
                    alt={getProductName(product) || 'Product image'}
                  />
                )}
              </div>

              <div className="py-3">
                {product.images && (
                  <Carousel
                    autoPlay={true}
                    infinite={true}
                    responsive={responsive}
                    transitionDuration={500}
                  >
                    {product.images?.map((img, i) => (
                      <div
                        key={i}
                        onClick={() => setImage(img)}
                        className="mx-2 aspect-square border rounded-md cursor-pointer"
                      >
                        <img
                          className="w-full h-full object-cover"
                          src={`${backend_url_img}/${img}`}
                          alt=""
                        />
                      </div>
                    ))}
                  </Carousel>
                )}
              </div>
            </div>

            <div className="flex flex-col gap-4">
              <div className="text-lg text-slate-600 font-bold">
                <h3>{getProductName(product)} </h3>
              </div>
              <div className="text-slate-600">
                <p className="text-slate-600 text-sm font-bold">
                  {t('products.product_code')} : {product.productCode}
                </p>
              </div>
              <div className="text-slate-600">
                <p className="text-slate-600 text-sm font-bold">
                  {t('products.brand')} : {product.category}
                </p>
              </div>
              <div className="flex justify-start items-center gap-4">
                <div className="flex text-xl">
                  <Rating ratings={product.rating} />
                </div>
                <p className="text-sm text-slate-600">
                  ({totalReview}) {t('products.reviews')}
                </p>
              </div>

              <div className="flex w-full justify-start sm:justify-center md:justify-start items-center sm:px-2 lg:px-14  py-3">
                <div className="grid grid-cols-3 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-3 gap-2">
                  {product.packs?.map((pack, index) => {
                    const isSelected =
                      selectedPacks[product._id]?.pack?.code === pack.pack.code

                    return (
                      <button
                        key={index}
                        onClick={() =>
                          setSelectedPacks((prev) => ({
                            ...prev,
                            [product._id]: pack,
                          }))
                        }
                        className={`h-20 md:h-24 flex flex-col items-center p-2 gap-1 border rounded-md 
            ${
              isSelected
                ? 'bg-[#B42A19] text-white'
                : 'bg-gray-100 text-bg-primary border-gray-200'
            }`}
                      >
                        <span className="text-center text-sm font-semibold">
                          {pack.pack.code} {getProductName(pack.pack)}
                        </span>

                        <span className="text-center text-xs font-normal">
                          {pack.price} {t('products.currency')} /{' '}
                          {getProductName(pack.pack)}
                        </span>

                        <span className="text-center text-sm font-semibold">
                          {new Intl.NumberFormat('en-US', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }).format(pack.price * pack.pack.code)}{' '}
                          {t('products.currency')}
                        </span>
                      </button>
                    )
                  })}
                </div>
              </div>

              <div className="text-lg  font-bold py-4 border-t-[1px] flex gap-3">
                {selectedPacks[product._id] ? (
                  <>
                    {t('products.price')} :{' '}
                    <h2>
                      {selectedPacks[product._id]
                        ? new Intl.NumberFormat('en-US', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }).format(
                            selectedPacks[product._id].price *
                              selectedPacks[product._id].pack.code
                          )
                        : ''}{' '}
                      {t('products.currency')}
                    </h2>
                  </>
                ) : null}

                {/* )} */}
              </div>

              <div className="flex justify-centerpy-2 gap-5">
                <div className="w-[150px] text-black font-bold text-sm flex flex-col gap-6">
                  <span>{t('products.availability')}</span>
                  <span>{t('products.share_on')}</span>
                </div>
                <div className="flex flex-col gap-3">
                  <span
                    className={`text-${product.stock ? 'green' : 'red'}-500`}
                  >
                    {product.stock
                      ? `In Stock(${product.stock})`
                      : 'Out Of Stock'}
                  </span>
                  <ul className="flex justify-start items-center gap-2">
                    <li>
                      <a
                        className="w-[35px] h-[35px] hover:bg-[#3b5998] hover:text-white flex justify-center items-center bg-[#8b9dc3] rounded-full text-white"
                        href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
                          window.location.href
                        )}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <FaFacebookF />
                      </a>
                    </li>
                    <li>
                      <a
                        className="w-[35px] h-[35px] hover:bg-[#E1306C] hover:text-white flex justify-center items-center bg-[#F56040] rounded-full text-white"
                        href="#"
                        onClick={() => {
                          navigator.clipboard.writeText(window.location.href)
                          alert('Link copied! You can share it on Instagram.')
                        }}
                      >
                        <FaInstagramSquare />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="flex gap-3 pt-5 border-t">
                {product.stock ? (
                  <div className="flex items-center gap-4 mt-2">
                    {/* Quantity selector */}
                    <div className="flex items-center border rounded-full gap-3 py-2 px-2">
                      <button
                        onClick={() =>
                          setQuantity((prev) => Math.max(1, prev - 1))
                        }
                        className="w-8 h-8 flex items-center justify-center  text-3xl font-medium"
                      >
                        -
                      </button>
                      <span className="min-w-[30px] text-center text-lg font-semibold">
                        {quantity}
                      </span>
                      <button
                        onClick={() => setQuantity((prev) => prev + 1)}
                        className="w-8 h-8 flex items-center justify-center  text-3xl font-medium"
                      >
                        +
                      </button>
                    </div>

                    {/* Add to Cart */}
                    <button
                      onClick={handleAddToCart}
                      className="bg-primary border text-base border-gray-300 text-white px-5 py-3 rounded-full transition-colors duration-300 hover:bg-darkRed hover:text-white"
                    >
                      {t('products.add_to_card')}
                    </button>
                    <button
                      onClick={add_wishlist}
                      className={`p-3 rounded-full flex items-center justify-center shadow-md transition-all duration-300 
                    ${
                      isFavorite ? 'bg-red-100' : 'bg-gray-100 hover:bg-red-100'
                    }`}
                    >
                      {isFavorite ? (
                        <FaHeart className="text-darkRed" size={24} />
                      ) : (
                        <FaRegHeart
                          className="text-gray-400 hover:text-darkRed"
                          size={24}
                        />
                      )}
                    </button>
                  </div>
                ) : (
                  ''
                )}

                <div></div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="w-[68%] md:w-[80%] sm:w-[90%] lg:w-[90%]  h-full mt-6 mx-auto">
        <ProductSpecifications product={product} />
      </div>

      <section>
        <div className="w-[68%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto mt-10 py-2 pb-6">
          <div className="flex flex-wrap">
            <div className="w-full md-lg:w-full">
              <div className="pr-4 md-lg:pr-0">
                <div className="w-[30%] md:w-[80%] sm:w-[90%] lg:w-[90%] border-b-[2px] py-1 grid grid-cols-2">
                  <button
                    onClick={() => setState('description')}
                    className={`py-1  px-5 text-sm font-bold rounded-tl-lg  rounded-tr-lg ${
                      state === 'description'
                        ? 'bg-primary text-white'
                        : 'bg-slate-200 text-slate-700'
                    } rounded-sm`}
                  >
                    {t('products.description')}{' '}
                  </button>
                  <button
                    onClick={() => setState('reviews')}
                    className={`py-1  px-5 text-sm font-bold rounded-tl-lg rounded-tr-lg ${
                      state === 'reviews'
                        ? 'bg-primary text-white'
                        : 'bg-slate-200 text-slate-700'
                    } rounded-sm`}
                  >
                    {t('products.reviews')}{' '}
                  </button>
                </div>

                <div>
                  {state === 'reviews' ? (
                    <Reviews product={product} />
                  ) : (
                    <p className="py-2 text-slate-600 text-justify">
                      {getProductDescription(product)}
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Recent Products */}
      {recentProducts.length > 0 ? (
        <section>
          <div className="w-[68%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mt-10 mx-auto">
            <div className="w-[20%] md:w-[80%] sm:w-[90%] lg:w-[90%] ">
              <h2 className="text-sm font-bold p-2 rounded-tl-lg rounded-tr-lg bg-slate-200  text-slate-600">
                {t('products.recently_viewed_products')}{' '}
              </h2>
            </div>
            <div className="py-3 border-t-[2px]">
              <Swiper
                slidesPerView="auto"
                breakpoints={{
                  1280: {
                    slidesPerView: 5,
                    spaceBetween: 15,
                  },
                  768: {
                    slidesPerView: 3,
                    spaceBetween: 12,
                  },
                  480: {
                    slidesPerView: 2,
                    spaceBetween: 10,
                  },
                  0: {
                    slidesPerView: 2,
                    spaceBetween: 5,
                  },
                }}
                spaceBetween={15}
                loop={true}
                autoplay={{
                  delay: 3000, // 1-second delay
                  disableOnInteraction: false, // Ensure autoplay continues after interaction
                }}
                pagination={{
                  clickable: true,
                  el: '.custom_bullet',
                }}
                modules={[Pagination, Autoplay]} // Add Autoplay module here
                className="mySwiper"
              >
                {recentProducts?.map((p, i) => (
                  <SwiperSlide key={i}>
                    <Link className="block p-1">
                      <div className="flex hover:shadow-md  flex-col pb-2 w-full gap-1 bg-white rounded-md border border-grey-200 h-[450px] sm:h-[400px]">
                        {/* Square Image Container */}
                        <div className="relative group overflow-hidden w-full aspect-square">
                          <div className="absolute top-2 right-2 bg-white text-red-500 border border-red-500 text-xs font-bold w-6 h-6 rounded-full flex justify-center items-center z-10">
                            18+
                          </div>

                          {/* {p.discount !== 0 && (
                                          <div className="absolute top-2 left-2 bg-red-500 text-white text-sm font-bold rounded-full w-10 h-10 flex items-center justify-center z-10">
                                            -{p.discount}%
                                          </div>
                                        )} */}
                          <Link to={`/product/details/${p.slug}`}>
                            <img
                              className="w-full h-full object-cover cursor-pointer "
                              src={`${backend_url_img}/${p.images[0]}`}
                              alt={getProductName(p)}
                            />
                          </Link>
                        </div>

                        {/* Product Details */}
                        <div className="w-full bg-gray-20   p-2">
                          <div className="flex w-full justify-center items-center flex-col px-0 gap-2 ">
                            {/* Product Name */}
                            <div className="w-full border-b-[1px]">
                              <Link to={`/product/details/${p.slug}`}>
                                <h2 className="text-sm font-semibold py-3 overflow-hidden text-ellipsis whitespace-nowrap">
                                  {getProductName(p)}
                                </h2>
                              </Link>
                            </div>
                            {/* <div className="flex justify-start items-center w-full border-b-[2px] gap-3">
              
                                          <h2 className="text-sm  py-2">
                                            {t('products.product_code')} :
                                          </h2>
                                          <h2 className="text-sm font-semibold text-primary">
                                            {p.productCode}
                                          </h2>
                   
                                        </div> */}
                          </div>
                          <div className="flex w-full flex-col gap-3">
                            {/* Pack Buttons */}
                            <div className="flex w-full items-center flex-col mt-3">
                              <div className="flex items-center gap-2">
                                {p.packs?.map((pack, index) => {
                                  const isSelected =
                                    selectedPacks[p._id]?.pack?.code ===
                                    pack.pack.code

                                  return (
                                    <button
                                      key={index}
                                      onClick={() =>
                                        setSelectedPacks((prev) => ({
                                          ...prev,
                                          [p._id]: pack,
                                        }))
                                      }
                                      className={`w-12 h-14 flex flex-col items-center justify-center border rounded-md text-sm font-semibold 
                        ${
                          isSelected
                            ? 'bg-darkRed text-white'
                            : 'bg-gray-100 text-bg-primary border-gray-200'
                        }
                      `}
                                    >
                                      <span className="text-center">
                                        {pack.pack.code}
                                      </span>
                                      <span className="text-center">
                                        {getProductName(pack.pack)}
                                      </span>
                                    </button>
                                  )
                                })}
                              </div>
                            </div>

                            <div className="flex justify-between items-center mt-2 text-sm font-semibold">
                              {/* Left side: discounted price */}
                              <span>
                                {selectedPacks[p._id]
                                  ? new Intl.NumberFormat('en-US', {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    }).format(
                                      selectedPacks[p._id].price -
                                        Math.floor(
                                          (selectedPacks[p._id].price *
                                            p.discount) /
                                            100
                                        )
                                    )
                                  : ''}{' '}
                                {t('products.currency')}
                                {'/'}
                                {getProductName(p.packs?.[0].pack)}
                              </span>

                              <span>
                                {selectedPacks[p._id]
                                  ? new Intl.NumberFormat('en-US', {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    }).format(
                                      selectedPacks[p._id].price *
                                        selectedPacks[p._id].pack.code
                                    )
                                  : ''}
                              </span>
                            </div>

                            <div className="flex w-full items-center flex-col mt-3">
                              <button
                                disabled={p.stock <= 0}
                                className={`px-3 py-2 rounded-full transition-colors duration-300 z-10
                                ${
                                  p.stock > 0
                                    ? 'bg-primary border border-gray-300 text-white hover:bg-darkRed hover:text-white'
                                    : 'bg-gray-400 border border-gray-300 text-gray-200 cursor-not-allowed'
                                }`}
                                onClick={() =>
                                  handleAddToCart(p, selectedPacks[p._id])
                                }
                              >
                                {t('products.add_to_card')}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Link>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>

            <div className="w-full flex justify-center items-center py-2">
              <div className="custom_bullet justify-center gap-3 !w-auto"></div>
            </div>
          </div>
        </section>
      ) : null}

      {/* Related Products */}
      {relatedProducts.length > 0 ? (
        <section>
          <div className="w-[68%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mt-14 mx-auto">
            <div className="w-[20%] md:w-[80%] sm:w-[90%] lg:w-[90%]">
              <h2 className="text-sm font-bold p-2 rounded-tl-lg rounded-tr-lg bg-slate-200  text-slate-600">
                {t('products.related_products')}{' '}
              </h2>
            </div>
            <div className="py-3 border-t-[2px] ">
              <Swiper
                slidesPerView="auto"
                breakpoints={{
                  1280: {
                    slidesPerView: 5,
                    spaceBetween: 15,
                  },
                  768: {
                    slidesPerView: 3,
                    spaceBetween: 12,
                  },
                  480: {
                    slidesPerView: 2,
                    spaceBetween: 10,
                  },
                  0: {
                    slidesPerView: 2,
                    spaceBetween: 5,
                  },
                }}
                spaceBetween={15}
                loop={true}
                autoplay={{
                  delay: 3000,
                  disableOnInteraction: false,
                }}
                pagination={{
                  clickable: true,
                  el: '.custom_bullet',
                }}
                modules={[Pagination, Autoplay]}
                className="mySwiper"
              >
                {relatedProducts?.map((p, i) => {
                  return (
                    <SwiperSlide key={i}>
                      <Link className="block p-1">
                        <div className="flex hover:shadow-md  flex-col pb-2 w-full gap-1 bg-white rounded-md border border-grey-200 h-[450px] sm:h-[400px]">
                          {/* Square Image Container */}
                          <div className="relative group overflow-hidden w-full aspect-square">
                            <div className="absolute top-2 right-2 bg-white text-red-500 border border-red-500 text-xs font-bold w-6 h-6 rounded-full flex justify-center items-center z-10">
                              18+
                            </div>

                            {/* {p.discount !== 0 && (
                                          <div className="absolute top-2 left-2 bg-red-500 text-white text-sm font-bold rounded-full w-10 h-10 flex items-center justify-center z-10">
                                            -{p.discount}%
                                          </div>
                                        )} */}
                            <Link to={`/product/details/${p.slug}`}>
                              <img
                                className="w-full h-full object-cover cursor-pointer "
                                src={`${backend_url_img}/${p.images[0]}`}
                                alt={getProductName(p)}
                              />
                            </Link>
                          </div>

                          {/* Product Details */}
                          <div className="w-full bg-gray-20   p-2">
                            <div className="flex w-full justify-center items-center flex-col px-0 gap-2 ">
                              {/* Product Name */}
                              <div className="w-full border-b-[1px]">
                                <Link to={`/product/details/${p.slug}`}>
                                  <h2 className="text-sm font-semibold py-3 overflow-hidden text-ellipsis whitespace-nowrap">
                                    {getProductName(p)}
                                  </h2>
                                </Link>
                              </div>
                              {/* <div className="flex justify-start items-center w-full border-b-[2px] gap-3">
              
                                          <h2 className="text-sm  py-2">
                                            {t('products.product_code')} :
                                          </h2>
                                          <h2 className="text-sm font-semibold text-primary">
                                            {p.productCode}
                                          </h2>
                   
                                        </div> */}
                            </div>
                            <div className="flex w-full flex-col gap-3">
                              {/* Pack Buttons */}
                              <div className="flex w-full items-center flex-col mt-3">
                                <div className="flex items-center gap-2">
                                  {p.packs?.map((pack, index) => {
                                    const isSelected =
                                      selectedPacks[p._id]?.pack?.code ===
                                      pack.pack.code

                                    return (
                                      <button
                                        key={index}
                                        onClick={() =>
                                          setSelectedPacks((prev) => ({
                                            ...prev,
                                            [p._id]: pack,
                                          }))
                                        }
                                        className={`w-12 h-14 flex flex-col items-center justify-center border rounded-md text-sm font-semibold 
                        ${
                          isSelected
                            ? 'bg-darkRed text-white'
                            : 'bg-gray-100 text-bg-primary border-gray-200'
                        }
                      `}
                                      >
                                        <span className="text-center">
                                          {pack.pack.code}
                                        </span>
                                        <span className="text-center">
                                          {getProductName(pack.pack)}
                                        </span>
                                      </button>
                                    )
                                  })}
                                </div>
                              </div>

                              <div className="flex justify-between items-center mt-2 text-sm font-semibold">
                                {/* Left side: discounted price */}
                                <span>
                                  {selectedPacks[p._id]
                                    ? new Intl.NumberFormat('en-US', {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      }).format(
                                        selectedPacks[p._id].price -
                                          Math.floor(
                                            (selectedPacks[p._id].price *
                                              p.discount) /
                                              100
                                          )
                                      )
                                    : ''}{' '}
                                  {t('products.currency')}
                                  {'/'}
                                  {getProductName(p.packs?.[0].pack)}
                                </span>

                                <span>
                                  {selectedPacks[p._id]
                                    ? new Intl.NumberFormat('en-US', {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      }).format(
                                        selectedPacks[p._id].price *
                                          selectedPacks[p._id].pack.code
                                      )
                                    : ''}
                                </span>
                              </div>

                              <div className="flex w-full items-center flex-col mt-3">
                                <button
                                  disabled={p.stock <= 0}
                                  className={`px-3 py-2 rounded-full transition-colors duration-300 z-10
                                ${
                                  p.stock > 0
                                    ? 'bg-primary border border-gray-300 text-white hover:bg-darkRed hover:text-white'
                                    : 'bg-gray-400 border border-gray-300 text-gray-200 cursor-not-allowed'
                                }`}
                                  onClick={() =>
                                    handleAddToCart(p, selectedPacks[p._id])
                                  }
                                >
                                  {t('products.add_to_card')}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Link>
                    </SwiperSlide>
                  )
                })}
              </Swiper>
            </div>

            <div className="w-full flex justify-center items-center py-8">
              <div className="custom_bullet justify-center gap-3 !w-auto"></div>
            </div>
          </div>
        </section>
      ) : null}

      <Footer />
    </div>
  )
}

export default Details
